// extracted by mini-css-extract-plugin
export var actionButton = "_5y-1";
export var actionButtons = "_5y-2";
export var actions = "_5y-0";
export var aiUnread = "_5y-10";
export var alignCenter = "_5y-h";
export var backWrapper = "_5y-3";
export var cellContainer = "_5y-4";
export var checkboxContainer = "_5y-5";
export var contentContainer = "_5y-6";
export var contentHeader = "_5y-8";
export var conversationsTableWrapper = "_5y-s";
export var draftReplyBadgeContainer = "_5y-m";
export var dropdownItem = "_5y-b";
export var dropdownItemsContainer = "_5y-a";
export var dropdownTitle = "_5y-c";
export var errorIcon = "_5y-7";
export var filter = "_5y-d";
export var gray = "_5y-i";
export var headerActionButtons = "_5y-e";
export var headerCheckboxContainer = "_5y-f";
export var icon = "_5y-j";
export var menuContainer = "_5y-k";
export var noMoreTicketsIcon = "_5y-12";
export var noMoreTicketsSubText = "_5y-13";
export var oneLine = "_5y-l";
export var optionsButton = "_5y-n";
export var plus = "_5y-o";
export var portalButtonsWrapper = "_5y-g";
export var red = "_5y-p";
export var scrolledTop = "_5y-9";
export var search = "_5y-q";
export var selectedConversationsCount = "_5y-r";
export var spinner = "_5y-t";
export var strong = "_5y-u";
export var summaryCell = "_5y-v";
export var tableContainer = "_5y-11";
export var tagContainer = "_5y-w";
export var threeDots = "_5y-x";
export var twoLines = "_5y-y";
export var unread = "_5y-z";